export function addDropDown() {

	const dropDown = document.querySelector('.drop-down')
  const rolloverItem = document.querySelector('.our-food-nav-item')
  const pointer = document.querySelector('.pointer')
  
  let menuHover = true
  
  rolloverItem.addEventListener('mouseover', (e)=> {
    let bBox = e.target.getBoundingClientRect()
    let xPos = (bBox.left + (bBox.width/2))
    pointer.style.left = `${xPos}px`
    dropDown.classList.add('show')
  })

  dropDown.addEventListener('mouseover', (e)=> {
    dropDown.classList.add('show')
    menuHover = true
  })

  dropDown.addEventListener('mouseout', (e)=> {
    dropDown.classList.remove('show')
    menuHover = false
  })

  rolloverItem.addEventListener('mouseout', ()=> {

    setTimeout(() => {
      if(menuHover) {
        return
      }

      dropDown.classList.remove('show')
    }, 500)
    
  })
}


// WEBPACK FOOTER //
// ./src/drop-down.js